export default __webpack_public_path__ + "static/media/admin.2c03c9ee.svg";